import { render, staticRenderFns } from "./rightTab.vue?vue&type=template&id=180d4b70"
import script from "./rightTab.vue?vue&type=script&lang=js"
export * from "./rightTab.vue?vue&type=script&lang=js"
import style0 from "./rightTab.vue?vue&type=style&index=0&id=180d4b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports